import React from 'react';
import TokenHistoryExplorer from '../../../components/skillcoin/member/TokenHistoryExplorer';
import { Box, Button, Typography } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';

const TokenHistoryPage = () => {
  const [refreshKey, setRefreshKey] = React.useState(0);

  const handleRefresh = () => {
    // Increment refresh key to force component remount
    setRefreshKey(prevKey => prevKey + 1);
  };

  return (
    <Box sx={{ py: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">Token Transaction History</Typography>
        <Button 
          variant="outlined" 
          startIcon={<RefreshIcon />} 
          onClick={handleRefresh}
          size="small"
        >
          Refresh
        </Button>
      </Box>
      <TokenHistoryExplorer key={refreshKey} forceRefresh={refreshKey} />
    </Box>
  );
};

export default TokenHistoryPage;